import {
  ClientReadableStream,
  Metadata,
  Request,
  RpcError,
  StreamInterceptor,
} from "grpc-web";
import {
  QuestionServiceClient,
  ResponseServiceClient,
  SectionServiceClient,
  SurveyServiceClient,
} from "../pb/surveys_grpc_web_pb";

export const surveyHostName = ():string => {
  return (process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_SURVEY_HOST_NAME_LOCAL
    : process.env.REACT_APP_SURVEY_HOST_NAME)??"";
};
export const surveyService = new SurveyServiceClient(
  surveyHostName(),
  null,
  null
);

export const responseService = new ResponseServiceClient(
  surveyHostName(),
  null,
  null
);
export const questionService = new QuestionServiceClient(
  surveyHostName(),
  null,
  null
);

export const sectionService = new SectionServiceClient(
  surveyHostName(),
  null,
  null
);




class AuthInterceptorStream<REQ extends Request<any, any>, RES = any>
  implements StreamInterceptor<REQ, RES>
{
  intercept(
    request: REQ,
    invoker: (request: REQ, metadata?: Metadata) => ClientReadableStream<RES>
  ) {
    const metadata = request.getMetadata();
    const token = localStorage.getItem("AuthToken");
    if (token) metadata["authorization"] = token;
    metadata["Content-Type"] = "application/grpc-web-text+proto";
    const stream = invoker(request);
    return new AuthReadableStreamWrapper<RES>(stream);
  }
}

class AuthReadableStreamWrapper<RES = any> {
  private stream: ClientReadableStream<RES>;

  constructor(stream: ClientReadableStream<RES>) {
    this.stream = stream;
  }

  on<F extends Function>(eventType: any, callback: F) {
    if (eventType === "error") {
      this.stream.on("error", (err: RpcError) => {
        callback(err);
      });
    } else if (eventType === "data") {
      this.stream.on("data", (resp) => {
        callback(resp);
      });
    } else if (eventType === "status") {
      this.stream.on("status", (status) => {
        callback(status);
      });
    } else if (eventType === "end") {
      this.stream.on("end", callback as any);
    }
    return this;
  }

  removeListener(eventType: any, callback: any) {
    this.stream.removeListener(eventType, callback);
  }

  cancel() {
    this.stream.cancel();
    return this;
  }
}

export { AuthInterceptorStream };
